import { useParams } from 'react-router-dom';
import MaintenanceContractTypesDetails from './components/maintenanceContractTypesDetails/MaintenanceContractTypesDetails';
import MaintenanceContractTypesList from './components/maintenanceContractTypesList/MaintenanceContractTypesList';
import styles from './MaintenanceContractTypesTab.module.scss';

const MaintenanceContractTypesTab = () => {
    const { type } = useParams<{ type: string, itemId: string }>();

    return <div className={styles.container}>
        {
            (type === 'list' ? <MaintenanceContractTypesList /> : <MaintenanceContractTypesDetails />)
        }
        </div>;
}

export default MaintenanceContractTypesTab;
